import { Grid } from "@mui/material";
import { settings } from "app";
import { ArrayInput, FormDataConsumer, ReferenceInput, required, SelectInput, SimpleFormIterator } from "react-admin";
import CustomTimeOnlyInput from "server/components/Fields/CustomTimeOnlyInput";
import ProfessorInput from "server/components/Fields/ProfessorInput";
import { CourseChoices, FromWeekToWeekChoices, WeekDaysChoices, WeekTypeChoices } from "utils/choices";
import { validateFromToWeek, validateTimeStart } from "../CreateWeeklySchedule/utils/utils";
import AcademicSessionIdFilterBlock from "../ForeignLanguagesSchedules/components/AcademicSessionIdFilterBlock";
import RoomInput from "server/components/Fields/RoomInput";
import { activityRequests } from "api/activityApi";

const CreateSaveForm = ({ hasSavedFilters }) => {
  return (
    <>
      <AcademicSessionIdFilterBlock hasSavedFilters={hasSavedFilters} />
      <Grid
        container
        spacing={2}
      >
        <ArrayInput
          source="activities"
          label="Разписания"
          sx={{ ml: 2, mt: 2 }}
          defaultValue={[{}]}
        >
          <SimpleFormIterator
            disableReordering
            disableClear
            sx={settings.style.iteratorWithoutGap}
          >
            <Grid
              container
              spacing={2}
            >
              <Grid
                item
                xs={12}
                md={6}
              >
                <ProfessorInput
                  source="professorEmployeeId"
                  fullWidth
                  filters={{ hasSport: true }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
              >
                <SelectInput
                  source="course"
                  label="Курс"
                  choices={CourseChoices}
                  optionValue="id"
                  optionText="name"
                  alwaysOn
                  emptyText={false}
                />
              </Grid>
              <FormDataConsumer>
                {({ scopedFormData }) => (
                  <>
                    <Grid
                      item
                      xs={12}
                      md={3}
                    >
                      <SelectInput
                        label="От седмица"
                        source="fromWeek"
                        choices={FromWeekToWeekChoices}
                        validate={[required(), () => validateFromToWeek(scopedFormData)]}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={3}
                    >
                      <SelectInput
                        label="До седмица"
                        source="toWeek"
                        choices={FromWeekToWeekChoices}
                        validate={[required(), () => validateFromToWeek(scopedFormData)]}
                      />
                    </Grid>
                  </>
                )}
              </FormDataConsumer>
              <Grid
                item
                xs={12}
                md={3}
              >
                <SelectInput
                  label="Тип седмица"
                  source="weekType"
                  choices={WeekTypeChoices}
                  validate={required()}
                  defaultValue={1}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={3}
              >
                <SelectInput
                  source="weekDay"
                  label="Ден от седмицата"
                  choices={WeekDaysChoices}
                  optionValue="id"
                  optionText="name"
                  validate={[required()]}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={8}
              >
                <RoomInput
                  source="roomId"
                  label="Зала"
                />
              </Grid>
              <FormDataConsumer>
                {({ scopedFormData }) => (
                  <>
                    <Grid
                      item
                      xs={12}
                      md={2}
                    >
                      <CustomTimeOnlyInput
                        source="startTime"
                        label="Започва в (час)"
                        validate={() => validateTimeStart(scopedFormData)}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={2}
                    >
                      <CustomTimeOnlyInput
                        source="endTime"
                        label="Приключва в (час)"
                        validate={() => validateTimeStart(scopedFormData)}
                      />
                    </Grid>
                  </>
                )}
              </FormDataConsumer>
              <Grid
                item
                xs={12}
                md={4}
              >
                <ReferenceInput
                  reference={activityRequests.getActivitySportSelect()}
                  source="sportId"
                >
                  <SelectInput
                    label="Избор на спорт"
                    optionText="nameBg"
                    validate={[required()]}
                  />
                </ReferenceInput>
              </Grid>
            </Grid>
          </SimpleFormIterator>
        </ArrayInput>
      </Grid>
    </>
  );
};

export default CreateSaveForm;
